import { useLogout } from '@Generic/logout/Logout';

const useCheckForLegacyMasquerade = () => {
  const { logoutUser } = useLogout();
  const legacyMasqueradeInfo = window.localStorage.getItem('current_admin');
  const newMasqueradeInfo = window.localStorage.getItem('admin-masquerade-info');
  if (legacyMasqueradeInfo && !newMasqueradeInfo) {
    try {
      const legacyMasqueradeInfoParsed = JSON.parse(legacyMasqueradeInfo);
      if (legacyMasqueradeInfoParsed?.super_admin_id) {
        window.localStorage.setItem('admin-masquerade-info', legacyMasqueradeInfoParsed.super_admin_id);
        logoutUser();
      }
    } catch (e) {
      // squash the error as the item probably wasn't there as the user probably wasn't in masquerade mode.
    }
  }
};

export default useCheckForLegacyMasquerade;
